import useFetch from '@hooks/useFetch';
import RecordedContentBanner from './RecordedContentBanner';

const offerings = {
  RECORDED_BATCH: 'recorded_batch'
};

const bannerDetailsEndpoint = (goalUID) => `v1/store/?goal_uid=${goalUID}`;

const Offerings = ({ goalUID, goalSlug }) => {
  const { data, isLoading } = useFetch(bannerDetailsEndpoint(goalUID));
  if (!isLoading && data && data.offerings?.length > 0) {
    return (
      <>
        {data.offerings.map((offering) => {
          if (offering.offeringType === offerings.RECORDED_BATCH)
            return (
              <RecordedContentBanner
                key={offering.uid}
                offering={offering}
                goalSlug={goalSlug}
                goalUID={goalUID}
              />
            );
          return null;
        })}
      </>
    );
  }
  return null;
};

export default Offerings;
